import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

const cardStyle = {
  width: '280px',
  height: '185px',
};
export const useCardStyles = makeStyles({
  card: cardStyle,
  cardSelected: {
    ...cardStyle,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralForeground2BrandHover),
  },
  checkmark: {
    position: 'absolute',
    top: '0',
    right: '0',
    width: '16px',
    height: '16px',
    marginTop: '16px',
    marginRight: '16px',
    color: tokens.colorNeutralForeground2BrandHover,
  },
  image: {
    ...shorthands.margin('8px'),
    height: '45px',
    width: '45px',
  },
  header: {
    maxHeight: '52px',
  },
  textArea: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginTop: '16px',
    marginBottom: '4px',
  },
});
